<template>
  <div id="acoes">
    <b-dropdown :disabled="disabled" no-caret menu-class="menu-principal">
      <template #button-content>
        <i class="icofont-navigation-menu"></i>
      </template>

      <button
        v-if="situacao != null && situacao.value == 'geral'"
        type="button"
        class="dropdown-item dropdown-item-custom"
        :disabled="salvando"
        @click.prevent.stop="salvar()"
      >
        <b-spinner small class="mr-2" v-if="salvando" />
        <i class="icofont-save" v-else></i>
        {{ salvando ? ' Salvando...' : ' Salvar histórico' }}
      </button>

      <b-dropdown-item v-if="pdfEnabled" href="#" @click="generatePdf()">
        <i class="icofont-file-pdf"></i> Exportar PDF
      </b-dropdown-item>

      <b-dropdown-item v-if="xlsEnabled" href="#" @click="postLog()">
        <download-excel
          :data="data"
          :fields="fields"
          worksheet="My Worksheet"
          :name="`${name}.xls`"
          class="acoes-xls"
        >
          <i class="icofont-file-excel"></i> Exportar XLS
        </download-excel>
      </b-dropdown-item>

      <div class="dropdown-submenu">
        <a href="#" class="dropdown-item submenu-toggle" @click.prevent>
          <span><i class="icofont-eye"></i> Ver histórico</span>
          <i class="icofont-simple-right"></i>
        </a>

        <div class="dropdown-menu submenu-menu">
          <a
            v-for="(item, index) in situacaoOptions"
            :key="index"
            href="#"
            class="dropdown-item"
            @click.prevent="verHistorico(item.value)"
          >
            {{ item.label }}
          </a>
        </div>
      </div>
    </b-dropdown>

    <b-modal
      id="modal-confirmar-novo-periodo"
      ref="modalNovoPeriodo"
      title="Salvar histórico"
      centered
      hide-footer
      @hidden="resetNovoPeriodoState"
    >
      <p>
        Já existe um relatório salvo
        <span v-if="historicoExistente?.quem_atualizou">
          por <strong>{{ historicoExistente.quem_atualizou }}</strong>
        </span>
        para o período
        {{ dataInicial ? formatDate(dataInicial) : '-' }} a
        {{ dataFinal ? formatDate(dataFinal) : '-' }}. Deseja salvar outro
        relatório para o mesmo período?
      </p>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="secondary"
          class="mr-2"
          :disabled="loadingNovoPeriodo"
          @click="fecharModalNovoPeriodo"
        >
          Não
        </b-button>

        <b-button
          variant="primary"
          :disabled="loadingNovoPeriodo"
          @click="confirmarNovoPeriodo"
        >
          Sim
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'Acoes',
  props: {
    data: {
      type: [Array, Boolean],
      default: () => [],
    },
    fields: {
      type: Object,
      default: () => ({}),
    },
    name: {
      type: String,
      default: 'file',
    },
    callbackPdf: {
      type: [Function, Boolean],
      default: false,
    },
    pdfEnabled: {
      type: Boolean,
      default: true,
    },
    xlsEnabled: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    situacao: {
      type: Object,
      default: () => null,
    },
    dataInicial: {
      type: String,
      default: '',
    },
    dataFinal: {
      type: String,
      default: '',
    },
    callbackHistorico: {
      type: [Function, Boolean],
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      salvando: false,
      loadingNovoPeriodo: false,
      resolverNovoPeriodo: null,
      historicoExistente: null,
      situacaoOptions: [
        {
          label: 'Geral',
          value: 'geral',
        },
        // {
        //   label: 'Gestantes',
        //   value: 'gestantes',
        // },
        // {
        //   label: 'Hipertensão',
        //   value: 'hipertensao',
        // },
        // {
        //   label: 'Diabetes',
        //   value: 'diabetes',
        // },
        // {
        //   label: 'Crianças até 5 anos',
        //   value: 'criancas',
        // },
        // {
        //   label: 'Idosos',
        //   value: 'idosos',
        // },
      ],
    }
  },
  methods: {
    getProfissionalSelecionado(item) {
      if (item.nu_micro_area === 'FA' || item.nu_micro_area === '--') {
        return 'Sem Agente de Saúde'
      }

      if (item.profissionalSelected) {
        return item.profissionalSelected
      }

      let profissionais = []

      if (Array.isArray(item.profissionais)) {
        profissionais = item.profissionais
      } else if (
        typeof item.noms_prof === 'string' &&
        item.noms_prof.trim() !== ''
      ) {
        try {
          profissionais = JSON.parse(item.noms_prof)
        } catch (e) {
          profissionais = []
        }
      }

      if (Array.isArray(profissionais) && profissionais.length === 1) {
        return profissionais[0]
      }

      return ''
    },

    resetNovoPeriodoState() {
      if (this.resolverNovoPeriodo) {
        this.resolverNovoPeriodo(false)
      }

      this.salvando = false
      this.loadingNovoPeriodo = false
      this.resolverNovoPeriodo = null
    },

    abrirConfirmNovoPeriodo() {
      this.resetNovoPeriodoState()

      return new Promise((resolve) => {
        this.resolverNovoPeriodo = resolve
        this.$refs.modalNovoPeriodo.show()
      })
    },

    fecharModalNovoPeriodo() {
      if (this.resolverNovoPeriodo) {
        this.resolverNovoPeriodo(false)
      }

      this.$refs.modalNovoPeriodo.hide()
      this.resetNovoPeriodoState()
    },

    confirmarNovoPeriodo() {
      this.loadingNovoPeriodo = true

      if (this.resolverNovoPeriodo) {
        this.resolverNovoPeriodo(true)
      }

      this.$refs.modalNovoPeriodo.hide()
    },

    async verHistorico(tipo) {
      if (!this.callbackHistorico) {
        return
      }

      await this.callbackHistorico(tipo)
    },

    generatePdf() {
      this.postLog()
      if (this.callbackPdf) {
        this.callbackPdf()
      }
    },

    postLog() {
      const payload = {
        id: this.$store.state.id,
        nome: this.$store.state.username,
        cod_ibge: this.$store.state.cod_ibge,
        page: this.$route.path,
      }
      this.$api.post('/app/logs/download', payload)
    },

    /**
     * Salva o histórico das microáreas.
     * @param {Boolean} confirmarMesmoPeriodo
     * @returns {Promise<void>}
     */
    async salvar(confirmarMesmoPeriodo = false) {
      const dataParaSalvar = this.data

      if (!Array.isArray(dataParaSalvar) || dataParaSalvar.length === 0) {
        this.$toast.error('Não há dados para salvar.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      const itensSemProfissional = dataParaSalvar.filter((item) => {
        const isSemAgente =
          item.nu_micro_area === 'FA' || item.nu_micro_area === '--'

        if (isSemAgente) return false

        const temMaisDeUmProfissional =
          Array.isArray(item.profissionais) && item.profissionais.length > 1

        return temMaisDeUmProfissional && !this.getProfissionalSelecionado(item)
      })

      if (itensSemProfissional.length > 0) {
        this.$toast.error(
          'Selecione o ACS / TACS das microáreas com mais de um profissional antes de salvar.',
          'Erro:',
          {
            position: 'topRight',
          }
        )
        this.$root.$emit('focus-select-profissional', itensSemProfissional[0])

        return
      }

      try {
        this.salvando = true

        const payload = {
          uuid_rel: uuidv4(),
          data_inicial: this.dataInicial,
          data_final: this.dataFinal,
          rel_tipo: this.situacao?.label || '',
          quem_atualizou: this.$store.state.username || '',
          confirmar_mesmo_periodo: confirmarMesmoPeriodo,
          historicos: dataParaSalvar.map((item) => ({
            ordem: item.ordem ?? null,
            no_unidade_saude: item.no_unidade_saude || '',
            nu_ine: item.nu_ine || '',
            nu_micro_area: item.nu_micro_area || '',
            no_prof_acs_tacs: this.getProfissionalSelecionado(item),
            dados: {
              co_equipe: item.co_equipe ?? null,
              visitadas: item.visitadas ?? 0,
              cadastradas: item.cadastradas ?? 0,
              cadastros_antigos: item.cadastros_antigos ?? 0,
              resultado: item.resultado ?? null,
              mudanca_territorio: item.mudanca_territorio ?? null,
            },
          })),
        }

        const response = await this.$api.post(
          `/app/microareas/${this.$store.state.cod_ibge}/historicos`,
          payload
        )

        if (response.data?.already_exists && !confirmarMesmoPeriodo) {
          this.historicoExistente = response.data.item || null

          const confirmado = await this.abrirConfirmNovoPeriodo()

          if (!confirmado) {
            return
          }

          await this.salvar(true)
          return
        }

        if (response.data?.error) {
          this.$toast.error(
            response.data.message || 'Erro ao salvar histórico.',
            'Erro:',
            {
              position: 'topRight',
            }
          )
          return
        }

        this.$toast.success(
          response.data.message || 'Histórico salvo com sucesso.',
          'Sucesso:',
          {
            position: 'topRight',
          }
        )
      } catch (error) {
        console.error(error)
        this.$toast.error('Erro ao salvar histórico.', 'Erro:', {
          position: 'topRight',
        })
      } finally {
        this.salvando = false
        this.resetNovoPeriodoState()
      }
    },
  },
}
</script>

<style>
#acoes button.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}

#acoes .dropdown-toggle::after {
  display: none;
}

/* só o menu principal */
#acoes .menu-principal {
  left: auto !important;
  right: 0 !important;
  padding: 5px 0;
  border-radius: initial !important;
  min-width: 220px;
}

#acoes .menu-principal .dropdown-item {
  padding: 8px 15px;
}

/* submenu */
#acoes .dropdown-submenu {
  position: relative;
}

#acoes .submenu-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#acoes .submenu-menu {
  position: absolute;
  top: 0;
  left: 100% !important;
  right: auto !important;
  margin-top: 0;
  display: none;
  min-width: 180px;
  padding: 5px 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  z-index: 1001;
}

#acoes .dropdown-submenu:hover .submenu-menu {
  display: block;
}

#acoes .dropdown-item-custom {
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  padding: 8px 15px;
  color: #212529;
}

#acoes .dropdown-item-custom:hover:not(:disabled),
#acoes .dropdown-item-custom:focus:not(:disabled) {
  background-color: #f8f9fa;
  outline: none;
}

#acoes .dropdown-item-custom:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
